import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MenuItem} from 'primeng/api';

import {KeycloakSupportService, UserService} from '@app/core';
import {BreadcrumbMain, BreadcrumbServices, Roles, RouteLink} from '@app/shared';
import {QlikAppName} from '@app/shared/enums/qlik-app-name.enum';
import {HomeComponent} from "@app/main/home/home.component";


@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css']
})
export class ServicesComponent implements OnInit {

  RouteLink: typeof RouteLink = RouteLink;
  Roles: typeof Roles = Roles;

  breadcrumb: MenuItem[] = [];
  tabName: string;
  activeIndex: number = 0;

  showQlikComponent: boolean;
  QlikAppName: typeof QlikAppName = QlikAppName;

  constructor(private router: Router, private route: ActivatedRoute,
              private keycloakSupport: KeycloakSupportService,
              public user: UserService) {
    this.showQlikComponent = false;
  }


  ngOnInit() {
    this.tabName = this.route.snapshot.params['tabName'];
    switch (this.tabName) {
      case 'ess': {
        this.activeIndex = 0;
        break;
      }
      case 'mss': {
        this.activeIndex = 1;
        break;
      }
      case 'hr': {
        this.activeIndex = 2;
        break;
      }
      case 'timeAndExpense': {
        this.activeIndex = 3;
        break;
      }
      case 'procurement': {
        this.activeIndex = 4;
        break;
      }
      case 'orders': {
        this.activeIndex = 5;
        break;
      }
      case 'finance': {
        this.activeIndex = 6;
        break;
      }
      case 'payroll': {
        this.activeIndex = 7;
        break;
      }
      case 'contract': {
        this.activeIndex = 8;
        break;
      }
      case 'projects': {
        this.activeIndex = 9;
        break;
      }
      case 'reporting': {
        this.activeIndex = 10;
        break;
      }
      case 'solution-mgr': {
        this.activeIndex = 11;
        break;
      }
      default: {
        this.activeIndex = 12;
        break;
      }
    }
    this.breadcrumb.push(BreadcrumbMain);
    this.breadcrumb.push(BreadcrumbServices);
  }

  qlikDashBoardPunchOut() {
    this.showQlikComponent = true;
    HomeComponent.initializedSub1.next(true);
    setTimeout(() => this.showQlikComponent = false, 10);
  }

  qlikPunchOut(component?: QlikAppName) {
    this.keycloakSupport.punchOutToQlik(component);
  }
}
